export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/zw.c65f4dfa.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};